import React, { useState } from "react";
import axios from "axios";
import Files from "react-files";
import { Base_URL } from "../url";
import { toast } from "react-toastify";



const uploadImg = "/assets/Images/uploadfiles.png"; // Use public URL
const uploadedFile = "/assets/Images/fileuploaded.png"; // Use public URL

const TripUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadMessage, setUploadMessage] = useState("");
  const [isUploaded, setIsUploaded] = useState(false);

  // Handle File Selection
  const onFilesChange = (files) => {
    if (files.length > 0) {
      setSelectedFile(files[0]);
      setIsUploaded(false);
    }
  };

  // Handle File Upload
  const handleUpload = async () => {
    if (!selectedFile) {
           toast.error(`🦄 Please Select a File`);
      return;
    }

    const formData = new FormData();
    formData.append("postedFile", selectedFile); // Use the correct API key

    try {
      const response = await axios.post(
        `${Base_URL}/TripDetails/TripExcelUpload?UserName=3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setUploadMessage(`File Uploaded Succcess with Trip-ID ${response.data}`);
      setIsUploaded(true);
      console.log(response.data)
    } catch (error) {
      console.error("Upload error:", error.response?.data || error.message);
      setUploadMessage("Error uploading file. Please try again.");
    }
  };

  // Function to download the Excel template
  const handleDownload = () => {
    const fileUrl = "/assets/Files/Trip_Excel.xlsx"; // Ensure this file exists in `public/assets/Files/`
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "Trip_Excel.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="tripupload-container">
        {/* Download Button at Top Right */}
        <div className="tripupload-header">
          <button className="download-btn" onClick={handleDownload}>
            Download Template
          </button>
        </div>

        {/* Upload Section in Center */}
        <div className="tripupload-content">
          {!isUploaded ? (
            <>
                 <h2 className="tripupload-title">Upload Trip Excel</h2>
              <Files
                className="files-dropzone"
                onChange={onFilesChange}
                accepts={[".xlsx"]}
                multiple={false}
                maxFileSize={50000000}
                minFileSize={0}
                clickable
              >
                <img src={uploadImg} height="300" width={"90%"} alt="Upload File" />
              </Files>
            </>
          ) : (
            <>
              <h5>File Uploaded</h5>
              <Files
                className="files-dropzone"
                onChange={onFilesChange}
                accepts={[".xlsx"]}
                multiple={false}
                maxFileSize={50000000}
                minFileSize={0}
                clickable
              >
                <img src={uploadedFile} height="300" width={"90%"} alt="File Uploaded" />
              </Files>
            </>
          )}

          {/* Show Selected File Name */}
          <p className="file-selected">
            {selectedFile ? `Selected File: ${selectedFile.name}` : "No file selected"}
          </p>

          <button className="upload-btn" onClick={handleUpload}>Submit</button>
          {uploadMessage && <p className="upload-message">{uploadMessage}</p>}
        </div>
      </div>
    </>
  );
};

export default TripUpload;
